window.addEventListener('load', (event) => {
  window.dispatchEvent(new Event('resize'));
  if(jQuery('.you-tube-video-section').length > 0) {
    if(!jQuery('.you-tube-video-section').hasClass('slick-initialized')){
      if(jQuery('.you-tube-video-section .video-wrapper').length > 0) {
        jQuery('.you-tube-video-section .video-wrapper').slick({ 
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "280px",
          
          responsive: [
                {
                  breakpoint: 1100,
                  settings: {
                       arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                     centerMode: false,
          centerPadding: "0",
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                       arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                           centerMode: false,
          centerPadding: "0",
                  }
                }
              ]
        });
      }


    }
  }


// custom homepage tab slider Js Start
var currentProductIds = {};

jQuery(document).on('click', '.carouselTabSection .tabBtn', function () {
  var currentFilter = jQuery(this).attr("data-filter-handle");
  jQuery('.carouselTabSection .tabBtn').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.tabSlider').addClass('hidden');
  jQuery(currentFilter).removeClass('hidden');
  
  // Retrieve the stored product ID for the current tab
    var dataid = jQuery(currentFilter).find('.swiper-slide-active').attr('data-product-id');
  // If a product ID is stored, set it as the current product for the tab
  if (dataid) {
    document.querySelector('.carouselTabSection').setAttribute('data-product-id', dataid);
  }
});
  // Function to update the current product ID for a tab
function updateCurrentProductId(slider, tab) {
  slider.on('slideChange', function (e) {
    // Get the active slide element
    var activeSlide = slider.slides[slider.activeIndex];
    
    // Get the data-producta-id attribute of the active slide
    var productId = activeSlide.getAttribute('data-product-id');

    // Store the product ID for the corresponding tab
    currentProductIds[tab] = productId;

    // Set the data-producta-id attribute of the parent section
    document.querySelector('.carouselTabSection').setAttribute('data-product-id', productId);
  });
}

// custom homepage tab Cocktail Mixers swiper js start
 // custom homepage tab Cocktail Mixers swiper js
  var swiperMixers = new Swiper(".swiper-mixers", {
    effect: "coverflow",
    grabCursor: false,
    centeredSlides: true,
    slidesPerView: "auto",
    preventClicks: false,
    loop: true,
    preventClicksPropagation: false,
    slideToClickedSlide: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 150,
      modifier: 1,
      slideShadows: false
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });

  updateCurrentProductId(swiperMixers, '.swiper-mixers');
// custom homepage tab Cocktail Mixers swiper js end

// custom homepage tab Cocktail Essentials swiper js start
var swiperEssentials = new Swiper(".swiper-essentials", {
	effect: "coverflow",
	grabCursor: false,
	centeredSlides: true,
	slidesPerView: "auto",
	preventClicks: false,
	loop: true,
    // slidesPerView: 5,
	preventClicksPropagation: false,
    slideToClickedSlide: true,
	coverflowEffect: {
		rotate: 0,
		stretch: 0,
		depth: 200,
		modifier: 1,
		slideShadows: false
	},
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
  updateCurrentProductId(swiperEssentials, '.swiper-essentials');
// custom homepage tab Cocktail Essentials swiper js end

// custom homepage tab Big Bucket swiper js start
var swiperBucket = new Swiper(".swiper-bucket", {
	effect: "coverflow",
	grabCursor: false,
	centeredSlides: true,
	slidesPerView: "auto",
	preventClicks: false,
	loop: true,
    // slidesPerView: 3,
	preventClicksPropagation: false,
    slideToClickedSlide: true,
	coverflowEffect: {
		rotate: 0,
		stretch: 0,
		depth: 300,
		modifier: 1,
		slideShadows: false
	},
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
updateCurrentProductId(swiperBucket, '.swiper-bucket');
// custom homepage tab Big Bucket swiper js end

// custom homepage tab Bold Flavor Adventure swiper js start
var swiperAdventure = new Swiper(".swiper-adventure", {
	effect: "coverflow",
	grabCursor: false,
	centeredSlides: true,
	slidesPerView: "auto",
	preventClicks: false,
	loop: true,
    // slidesPerView: 1,
	preventClicksPropagation: false,
    slideToClickedSlide: true,
	coverflowEffect: {
		rotate: 0,
		stretch: 0,
		depth: 150,
		modifier: 1,
		slideShadows: false
	},
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
updateCurrentProductId(swiperAdventure, '.swiper-adventure');
// custom homepage tab Bold Flavor Adventure swiper js end

  
  
// Toggle class in filter dropdown
jQuery(".filterBtn").click(function(){
  jQuery(".dropdownMenu").toggleClass("show");
  jQuery(".filterBtn").toggleClass("filter-active"); // Replace "anotherClass" with the class you want to toggle
});
  
// Tools & Techniques page Tab Js Start
  jQuery(document).on('click', '.filter_btn', function(){
  var currentFilter = jQuery(this).attr("data-filter-handle");
  jQuery('.filter_btn').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.hide-Techniques').hide();
  jQuery(currentFilter).show();
});
// Tools & Techniques page Tab Js End


  // Blog equal Article Start
  var elements = document.querySelectorAll('.blog-gridSection-wrapper');
function addClassToDivsByArticleId() {
  // Create an object to keep track of div elements by their article IDs
  var divsByArticleId = {};

  // Select all div elements on the page with data-article-id attributes
  var allDivs = document.querySelectorAll('div[data-article-id]');

  // Loop through each div element
  for (var i = 0; i < allDivs.length; i++) {
    var currentDiv = allDivs[i];
    var articleId = currentDiv.getAttribute('data-article-id');

    // Check if the articleId already exists in the object
    if (divsByArticleId.hasOwnProperty(articleId)) {
      // Add a class to the matching div
      currentDiv.classList.add('equal-article');
    } else {
      // If it doesn't exist, add the div to the object
      divsByArticleId[articleId] = currentDiv;
    }
  }
}

addClassToDivsByArticleId();
      // Blog equal Article End
  
                  // Product Page Start
 // function addClassToUncurrentDivs() {
 //          var currentProductId = document.querySelector('.current-slide-item[data-product-id]').getAttribute('data-product-id');

 //          // Select all uncurrent div elements on the page with data-product-id attributes
 //          var uncurrentDivs = document.querySelectorAll('.uncurrent-slide-item[data-product-id]');

 //          // Loop through each uncurrent div element
 //          for (var i = 0; i < uncurrentDivs.length; i++) {
 //            var currentDiv = uncurrentDivs[i];
 //            var productId = currentDiv.getAttribute('data-product-id');

 //            // Check if the productId matches the current slide's productId
 //            if (productId === currentProductId) {
 //              // Add a class to the matching uncurrent div
 //              currentDiv.classList.add('matched-product');
 //            }
 //          }
 //        }

 //        addClassToUncurrentDivs();
  // Product Page End




 



  
});



  // Background Video Js Start
jQuery(document).on('click', '.cover', function () {
    jQuery(this).children().css({
      'z-index' : 1,
      'opacity': 1
    });
});
// Background Video Js End



  

// Print Js Start
function printSection(articleId) {
    var printSectionId = 'printSection-' + articleId;
    var printContent = document.getElementById(printSectionId).innerHTML;

    // Add print media CSS styles with font import
    var printStyles = '<style type="text/css">' +
                      '@import url("https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Barlow+Semi+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");' +
                      '@media print {' +
                      '    /* Your print styles go here */' +
                      '    * { color: #000; }' +
                      '    .promobox__text-1, body, h3, .promobox__text-2, .feature-title, .feature-recipetitle { font-family: "Barlow", sans-serif !important; }' +
                      '    .promobox__text-1 { font-size: 18px; text-transform: uppercase; line-height: 1.3em; margin-bottom: 5px;font-weight: bold; }' +
                      '    .right-side-blog, .button-wrapper, .social-icons, .feature-title, .breadcrumbs,.feature-recipetitle { display: none; }' +
                      '   .promobox__text-2, h3 { font-size: 40px; color: #000 !important; text-transform: uppercase; margin-top: 30px;font-weight: bold; }' +
                      '    .promobox__text-2 a { font-size: 40px; color: #000 !important; text-transform: uppercase; text-decoration: unset !important;font-weight: bold; }' +
                     '    .openion-title { font-weight: bold; }' +
                      '    /* Add more print styles as needed */' +
                      '}' +
                      '</style>';
    
    printContent = printStyles + printContent;

    // Create a new iframe
    var printIframe = document.createElement('iframe');
    printIframe.style.display = 'none';
    document.body.appendChild(printIframe);

    // Write the content to the iframe
    printIframe.contentDocument.write(printContent);
    printIframe.contentDocument.close();

    // Print the iframe content
    printIframe.contentWindow.print();

    // Remove the iframe
    document.body.removeChild(printIframe);
}


// Print Js End


